import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

import checkmark from '../../../../../images/purple-checkmark.svg';

export const StatementWrapper = styled.div`
  margin-top: 3rem;
  margin-bottom: 3rem;
`;

export const Title = styled.p`
  text-align: center;
  font-size: 1.5rem;
  font-weight: ${themeGet('fontWeights.medium')};
  line-height: 140%;
  margin-bottom: 1.25rem;
`;

export const Body = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

export const Ulist = styled.ul`
  margin-left: 0;
  margin-bottom: 2rem;
  li {
    margin: 0.625rem 0;
    list-style: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    p {
      margin: unset;
    }
  }
  li::before {
    content: '';
    display: inline-block;
    min-height: 1.8125rem;
    min-width: 1.8125rem;
    margin-right: 1.25rem;
    background-image: url(${checkmark});
    background-size: cover;
    background-position: center;
  }
  > li:not(:first-child) {
    margin: 0.625rem 0;
  }
`;

export const Olist = styled.ol`
  margin-bottom: 2rem;
  li {
    margin: 0.625rem 0;
    display: flex;
    flex-direction: row;
    p {
      margin: unset;
    }
  }

  > li:not(:first-child) {
    margin: 0.625rem 0;
  }
`;
